import { render } from "./ForgotPasswordPage.vue?vue&type=template&id=dd3b62a0&ts=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__